import { IInventoryPage } from '../../../../../inventory-page.interface';


export const RESEARCH_RESEARCH_DETAIL_BY_TYPE_BY_ASIN_PAGE: IInventoryPage = {
	'route': '/research/research/detail/:type/:asin',
	'title': 'Keywords',
	'uiReference': [
		'Enter tag (optional)',
		'BSR',
		'Sales',
		'Price',
		'Reviews',
		'review(s)',
		'Updated :',
		'by:',
		'Refreshing',
		'ASIN :',
		'N/A',
		'Bulletpoints',
		'Subtitle',
		'Description',
		'Meta Keywords',
		'Open in Amazon',
		'Open Listing in KW Workbench',
		'Open Keywords in KW Workbench',
		'Similar Designs',
		'Open in Search',
		'Same Brand',
		'Add',
		'Competitors',
		'Average Deviation',
		'Ranking',
		'Best Seller Rank History',
		'n/a',
		'Sales and Price History',
		'Trademark Check',
		'Loading...',
		'Competition',
		'Sorry, there was an internal error. Please contact support.',
		'Remove from favorites',
		'Enter a tag',
		'Favorite tag',
		'Generate image using AI',
		'NEW',
		'History Rank :',
		'History Price : NA',
		'Removed',
		'ASIN',
		'Published since',
		'Saved',
		'Update tag'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/research-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/design-detail/design-detail.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/design-detail/design-detail.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/highlight-text/highlight-text.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/highlight-text/highlight-text.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/design-detail/design-detail-metrics/design-detail-metrics.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/design-detail/design-detail-metrics/design-detail-metrics.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/design-detail/design-detail-metrics/design-detail-metrics.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/preview/word-frequency-keyword/word-frequency-keyword.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/preview/word-frequency-keyword/word-frequency-keyword.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/design-carousel/design-carousel.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/design-carousel/design-carousel.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/api-loading-card/api-loading-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/api-loading-card/api-loading-card.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/chart/chart.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/chart/chart.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/design-mba/design-mba.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/design-mba/design-mba.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/trends-badge/trends-badge.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/trends-badge/trends-badge.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/add-to-favorite/add-to-favorite.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/add-to-favorite/add-to-favorite.component.html'
	]
};
